<div class="tree-item">
	@if (expanded) {
		<mat-icon class="expand-icon" [ngClass]="childrenBoxes.length !== 0 ? 'icon-display' : 'icon-hidden'" (click)="onExpand()">remove</mat-icon>
	} @else {
		<mat-icon class="expand-icon" [ngClass]="childrenBoxes.length !== 0 ? 'icon-display' : 'icon-hidden'" (click)="onExpand()">add</mat-icon>
	}
	<div class="tree-item-value">
		<table class="branch">
			<tr class="nodeHeader">
				<td class="nodeName">
					<span>{{ boxGroup.name }}</span>
				</td>
			</tr>
			<tr>
				<td class="nodeInfo">
					@if (isIdVisible === true) {
						<span>id&nbsp;:&nbsp;{{ boxGroup.id }}</span>
					}
					<span>order&nbsp;:&nbsp;{{ boxGroup.order }}</span>
				</td>
			</tr>
		</table>
	</div>
</div>

@if (childrenBoxes.length !== 0 && expanded) {
	<div class="tree-item-children">
		@for (box of childrenBoxes; track box) {
			<div class="tree-item-child">
				<app-box-tree-item
					[box]="box"
					(itemDisplayed)="onBoxDisplayed($event)"
					(itemEdited)="onBoxEdited($event)"
					(itemDeleted)="onBoxDeleted($event)"
					(itemDuplicated)="onBoxDuplicated($event)"></app-box-tree-item>
			</div>
		}
	</div>
}
